export const pxToRem = (px: number) => `${px / 14}rem`;
